import { Box, Checkbox } from '@mui/material';
import React from 'react';

const RuleCheckBox = ({
  row,
  callback,
  id,
}: {
  row: any;
  callback: Function;
  id: string;
}) => (
    <Box display="flex" justifyContent="flex-start">
      <Checkbox id={id} checked={row.isEnabled} onChange={()=>{callback(row)}}/>
    </Box>
  );

export default RuleCheckBox;
